import axios from 'axios'
import {MessageBox, Message} from 'element-ui'
import store from '@/store'
import {getToken} from '@/utils/auth'
import {baseURL} from '@/settings'
// create an axios instance
const service = axios.create({
    //baseURL: process.env.NODE_ENV === 'development'?'/api':process.env.VUE_APP_BASE_API,
    baseURL: baseURL,
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        if (store.getters.token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['token'] = getToken()
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        // if the custom code is not 20000, it is judged as an error.
        if (res.code === 0 || res.code === 200) {
            return res
        } else {
            Message({
                message: res.msg || 'Error',
                type: 'error',
                duration: 5 * 1000
            })

            // 600: 登录失效;
            if (res.code === 600) {
                store.dispatch('user/resetToken').then(() => {
                    location.reload()
                })
                // MessageBox.confirm('您登录时间已经过期', '重新登录', {
                //     confirmButtonText: '重新登录',
                //     // cancelButtonText: '取消',
                //     type: 'warning'
                // }).then(() => {
                //     store.dispatch('user/resetToken').then(() => {
                //         location.reload()
                //     })
                // })
                //
                // MessageBox.$alert('您登录时间已经过期', '提示', {
                //     confirmButtonText: '确定',
                //     callback: action => {
                //         store.dispatch('user/resetToken').then(() => {
                //             location.reload()
                //         })
                //     }
                // });
            }
            return Promise.resolve(new Error(res.message || 'Error'))
        }
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
